import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dialog, Slide } from '@mui/material';
import { Icon } from '@iconify/react';
import { deleteOccupant } from '../../../../../redux/actions/SocietyPortal/OccupantAction/OccupantAction';
import { memberDisplayName } from './tenancyStatus';

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

const DeleteMemberModal = ({
    open,
    handleClose,
    member,
    type,
    onSuccess,
}) => {
    const dispatch = useDispatch();
    const { deleteLoading } = useSelector(state => state.OccupantReducer);

    const fullName = member ? memberDisplayName(member) : '';

    const onConfirm = () => {
        if (!member) return;

        dispatch(deleteOccupant({
            id: member.flat_ownership_id || member.occupant_id,
            type,
            onSuccess: () => {
                handleClose();
                if (onSuccess) onSuccess();
            },
        }));
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            TransitionComponent={Transition}
            maxWidth="xs"
            fullWidth
            PaperProps={{ sx: { borderRadius: '12px' } }}
        >
            <div className="tw-bg-white tw-flex tw-flex-col">
                {/* Header */}
                <div className="tw-px-4 tw-py-3 tw-border-b tw-border-gray-200 tw-flex tw-items-center tw-justify-between">
                    <div className="tw-flex tw-items-center tw-gap-2.5">
                        <div className="tw-w-8 tw-h-8 tw-rounded-lg tw-bg-red-50 tw-flex tw-items-center tw-justify-center">
                            <Icon icon="mdi:delete-outline" className="tw-text-red-600 tw-text-base" />
                        </div>
                        <h3 className="tw-text-sm tw-font-semibold tw-text-gray-800">Delete Member</h3>
                    </div>
                    <button
                        onClick={handleClose}
                        className="tw-w-7 tw-h-7 tw-rounded-md tw-text-gray-400 hover:tw-text-gray-600 hover:tw-bg-gray-100 tw-flex tw-items-center tw-justify-center tw-transition-colors"
                    >
                        <Icon icon="mdi:close" className="tw-text-lg" />
                    </button>
                </div>

                {/* Body */}
                <div className="tw-px-5 tw-py-6 tw-text-center">
                    <div className="tw-w-12 tw-h-12 tw-rounded-full tw-bg-red-100 tw-flex tw-items-center tw-justify-center tw-mx-auto tw-mb-4">
                        <Icon icon="mdi:alert-outline" className="tw-text-red-500 tw-text-2xl" />
                    </div>
                    <p className="tw-text-sm tw-text-gray-700 tw-font-medium tw-mb-1">
                        Are you sure you want to delete?
                    </p>
                    {fullName && (
                        <p className="tw-text-base tw-font-semibold tw-text-gray-900 tw-mb-2">
                            {fullName}
                        </p>
                    )}
                    <p className="tw-text-xs tw-text-gray-500">
                        This action cannot be undone. The member will be permanently removed.
                    </p>
                </div>

                {/* Footer */}
                <div className="tw-px-5 tw-py-3 tw-bg-gray-50 tw-border-t tw-border-gray-100 tw-flex tw-items-center tw-gap-3">
                    <button
                        type="button"
                        onClick={handleClose}
                        disabled={deleteLoading}
                        className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-2 tw-border tw-border-gray-200 tw-rounded-lg tw-text-sm tw-font-medium tw-text-gray-600 hover:tw-bg-gray-100 tw-transition-colors disabled:tw-opacity-50"
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={onConfirm}
                        disabled={deleteLoading}
                        className="tw-flex-1 tw-flex tw-items-center tw-justify-center tw-gap-2 tw-px-4 tw-py-2 tw-bg-red-600 tw-text-white tw-rounded-lg tw-text-sm tw-font-medium hover:tw-bg-red-700 tw-transition-colors disabled:tw-opacity-50"
                    >
                        {deleteLoading ? (
                            <>
                                <div className="tw-animate-spin tw-rounded-full tw-h-4 tw-w-4 tw-border-2 tw-border-white tw-border-t-transparent"></div>
                                Deleting...
                            </>
                        ) : (
                            <>
                                <Icon icon="mdi:delete-outline" className="tw-text-base" />
                                Delete
                            </>
                        )}
                    </button>
                </div>
            </div>
        </Dialog>
    );
};

export default DeleteMemberModal;
